import * as Yup from 'yup';
import ConstReg from 'helper/form/constantRegex';
import { getMessValidate } from 'helper/form/messValidate';
import { isEmptyAndBlank, isBlank } from 'utils/common/StringUtils';
const checkNumber = (txtField, length = 0, isRequired = false) => {
  return Yup.mixed().test({
    name: 'checkNumber',
    test: function(value) {
      const msgCheckNum = getMessValidate('C0000006', [txtField]);
      const msgRequired = getMessValidate('C0000001', [txtField]);
      const msgRegNum = getMessValidate('C0000003', [txtField]);
      const msgLength = getMessValidate('C0000007', [txtField]);
      if (!isEmptyAndBlank(value)) {
        const flagIsNumber = ConstReg.regxNumberOnly.test(value);
        if (!flagIsNumber) {
          return this.createError({
            message: msgCheckNum,
          });
        }
        if (length) {
          if (value.length > length) {
            return this.createError({
              message: msgLength,
            });
          }
        }
      } else if (isRequired) {
        return this.createError({
          message: msgRequired,
        });
      }
      return true;
    },
  });
};
const checkWithRegx = (
  txtField,
  strRegx,
  messCheckRegx,
  length = 0,
  isRequired = false,
  min = 0,
) => {
  return Yup.mixed().test({
    name: 'checkWithRegx',
    test: function(value) {
      const msgCheckNum = getMessValidate(messCheckRegx, [txtField]);
      const msgRequired = getMessValidate('C0000001', [txtField]);
      const msgLength = getMessValidate('C0000007', [txtField]);
      const msgMin = getMessValidate('C0000007', [txtField]);
      if (!isEmptyAndBlank(value)) {
        const flagIsNumber = strRegx.test(value);
        if (!flagIsNumber) {
          return this.createError({
            message: msgCheckNum,
          });
        }
        if (length) {
          if (value.length > length) {
            return this.createError({
              message: msgLength,
            });
          }
        }
        if (value.length < min) {
          return this.createError({
            message: msgMin,
          });
        }
      } else if (isRequired) {
        return this.createError({
          message: msgRequired,
        });
      } else if (isBlank(value)) {
        const flagIsNumber = strRegx.test(value);
        if (!flagIsNumber) {
          return this.createError({
            message: msgCheckNum,
          });
        }
      }
      return true;
    },
  });
};
const checkNumberMoney = (txtField, length = 0, isRequired = false) => {
  return Yup.mixed().test({
    name: 'checkNumberMoney',
    test: function(value) {
      const msgCheckNum = getMessValidate('C0000006', [txtField]);
      const msgRequired = getMessValidate('C0000001', [txtField]);
      const msgRegNum = getMessValidate('C0000003', [txtField]);
      const msgLength = getMessValidate('C0000007', [txtField]);
      if (!isEmptyAndBlank(value)) {
        if (!isNaN(value)) {
          if (parseInt(value) < 0) {
            return this.createError({
              message: msgCheckNum,
            });
          }
        }
        const flagIsNumber = ConstReg.regxNumberOnly.test(value);
        if (!flagIsNumber) {
          return this.createError({
            message: msgRegNum,
          });
        }
        if (length) {
          if (value.length > length) {
            return this.createError({
              message: msgLength,
            });
          }
        }
      } else if (isRequired) {
        return this.createError({
          message: msgRequired,
        });
      }
      return true;
    },
  });
};
const checkEmptyString = (txtField, length = 0, isRequired = false) => {
  return Yup.mixed().test({
    name: 'checkEmptyString',
    test: function(value) {
      const msgRequired = getMessValidate('C0000001', [txtField]);
      const msgLength = getMessValidate('C0000007', [txtField]);
      if (!isEmptyAndBlank(value)) {
        if (length) {
          if (value.length > length) {
            return this.createError({
              message: msgLength,
            });
          }
        }
      } else if (isRequired) {
        return this.createError({
          message: msgRequired,
        });
      }
      return true;
    },
  });
};
Yup.addMethod(Yup.string, 'checkEmptyString', checkEmptyString);
Yup.addMethod(Yup.string, 'checkWithRegx', checkWithRegx);
Yup.addMethod(Yup.string, 'checkNumber', checkNumber);
Yup.addMethod(Yup.string, 'checkNumberMoney', checkNumberMoney);
